<ng-container *ngIf="!isLoading; else loading">
	<div class="card-title" translate>dashboard.documents-since-last-connection</div>
	<div class="doc-connection-list">
		<button *ngIf="showOa" type="button" mat-button class="doc-connection-row" (click)="goToDatacenter('OA')">
			<span class="doc-connection-main">
				<span translate>order.card.document.order.acknowledgments</span>
				<span class="doc-connection-count">{{ oaCount }}</span>
			</span>
			<mat-icon iconPositionEnd class="doc-connection-chevron" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
		<button *ngIf="showDa" type="button" mat-button class="doc-connection-row" (click)="goToDatacenter('DA')">
			<span class="doc-connection-main">
				<span translate>datacenter-filter.dispatch-advice</span>
				<span class="doc-connection-count">{{ daCount }}</span>
			</span>
			<mat-icon iconPositionEnd class="doc-connection-chevron" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
		<button *ngIf="showCe" type="button" mat-button class="doc-connection-row" (click)="goToDatacenter('CE')">
			<span class="doc-connection-main">
				<span translate>order.card.document.certificates</span>
				<span class="doc-connection-count">{{ ceCount }}</span>
			</span>
			<mat-icon iconPositionEnd class="doc-connection-chevron" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
		<button *ngIf="showIn" type="button" mat-button class="doc-connection-row" (click)="goToDatacenter('IN')">
			<span class="doc-connection-main">
				<span translate>commercial-documents.invoice</span>
				<span class="doc-connection-count">{{ inCount }}</span>
			</span>
			<mat-icon iconPositionEnd class="doc-connection-chevron" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
		<button *ngIf="showXcarb" type="button" mat-button class="doc-connection-row" (click)="goToDatacenter('XCARB')">
			<span class="doc-connection-main">
				<span translate>order.card.xcarb</span>
				<span class="doc-connection-count">{{ xcarbCount }}</span>
			</span>
			<mat-icon iconPositionEnd class="doc-connection-chevron" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
